import $ from 'jquery'
import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'
import URI from 'urijs'
import config from '@/config/env'

import api from '@/api/api'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import DateField from '@/components/general/fields/date/date'
import SearchField from '@/components/general/fields/search/search'
import FileField from '@/components/general/fields/file/file'

const Parse = require('parse')

export default {
  name: 'contracts-sda',
  data () {
    return {
      SDAsInfo: [],
      menuOptions: [
        {
          iconClass: 'fa fa-archive',
          name: this.$t('private.contracts.sda.menu_more_options.archive_contract'),
          action: 'archive'
        }
      ],
      filters: {
        since: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.since'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        until: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.until'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        exported: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
          value: 'all',
          name: this.$t('private.reports.sda.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
            value: 'all'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.only_exported'),
            value: 'only_exported'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.not_exported'),
            value: 'not_exported'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.limit_options.50'),
          value: 50,
          name: this.$t('private.reports.sda.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        seller: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.seller'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        delegation: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.delegation'),
          error: false,
          active: false,
          options: [],
          style: {
            width: '120px',
            marginTop: '0px'
          }
        },
        clientCode: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.client_code'),
          type: 'text',
          error: false,
          style: {
            width: '150px',
            marginTop: '0px'
          }
        },
        legalName: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        skip: {
          value: 0
        }
      },
      createContractWindow: {
        display: false,
        form: {
          fields: {
            client: {
              id: _.uniqueId('field_'),
              display: true,
              fakeValue: '',
              value: '',
              name: this.$t('private.contracts.sda.create_contract_window.fields.client'),
              error: false,
              active: false,
              options: [],
              filters: {
                type: 'string',
                required: true
              }
            },
            sdaTypes: {
              id: _.uniqueId('field_'),
              display: true,
              name: this.$t('private.contracts.sda.create_contract_window.fields.sda_types'),
              error: false,
              value: {
                // sdaSp  : false,
                // sdaSpInternet  : false,
                // sdaSpMen : false,
                // sdaSystemEC: false,
                sdaSebastian: false
                // sdaSebastianInternet : false,
                // sdaGHD : false,
                // sdaWedo : false
              },
              options: {
                // sdaSp : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sp'),
                // 	disabled : false
                // },
                // sdaSpInternet : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sp_internet'),
                // 	disabled : false
                // },
                // sdaSpMen : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sp_men'),
                // 	disabled : false
                // },
                // sdaSystemEC: {
                //   name: this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_system_ec'),
                //   disabled: false
                // },
                sdaSebastian: {
                  name: this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sebastian'),
                  disabled: false
                },
                // sdaSebastianInternet : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sebastian_internet'),
                // 	disabled : false
                // },
                // sdaGHD : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_ghd'),
                // 	disabled : false
                // },
                // sdaWedo : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_wedo'),
                // 	disabled : false
                // }
              },
              filters: {
                type: 'manyOptions',
                enum: [
                  // 'sdaSp',
                  // 'sdaSystemEC',
                  'sdaSebastian'
                  // 'sdaSebastianInternet',
                  // 'sdaGHD',
                  // 'sdaWedo'
                ]
              }
            },
            date: {
              id: _.uniqueId('field_'),
              display: true,
              fakeValue: '',
              value: '',
              name: this.$t('private.contracts.sda.create_contract_window.fields.date'),
              error: false,
              active: false,
              filters: {
                type: 'date'
              }
            },
            pdf: {
              id: _.uniqueId('field_'),
              display: true,
              value: {},
              name: this.$t('private.contracts.sda.create_contract_window.fields.pdf'),
              pdf: true,
              readAsDataURL: true,
              fileReady: false,
              error: false,
              active: false,
              filters: {
                type: 'file',
                maxSize: 30,
                formatsAllowed: ['pdf'],
                required: true
              }
            }
          },
          active: false
        }
      },
      migrateSDAsWindow: {
        display: false,
        migrateCSVFileActiveNormal: false,
        migrateCSVFileActiveDiamond: false,
        migrateCSVFileActiveInfo: false,
        normalSDAsToCreated: [],
        normalSDAsWithErrors: [],
        diamondSDAsToCreated: [],
        diamondSDAsWithErrors: [],
        SDAsInfoToUpdated: [],
        SDAsInfoWithErrors: [],
        fields: {
          separator: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csvNormal: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: 'Cargar CSV - SDAs Normal',
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          },
          csvDiamond: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: 'Cargar CSV - SDAs Diamond',
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          },
          csvInfo: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: 'Cargar CSV - SDAsInfo',
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      getSDAsInfoActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      displayFoo: false,
      exportZipPDFsWindow: {
        display: false,
        downloadZipPDFsActive: false,
        fields: {
          month: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month'),
            error: false,
            active: false,
            options: [],
            // options : [{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.january'),
            // 	value : '01'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.february'),
            // 	value : '02'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.march'),
            // 	value : '03'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.april'),
            // 	value : '04'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.may'),
            // 	value : '05'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.june'),
            // 	value : '06'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.july'),
            // 	value : '07'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.august'),
            // 	value : '08'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.september'),
            // 	value : '09'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.october'),
            // 	value : '10'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.november'),
            // 	value : '11'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.december'),
            // 	value : '12'
            // }],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.sda.export_zip_pdfs_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        },
        progress: {
          display: false,
          value: 0,
          valueMax: 0,
          download: 0
        }
      }
    }
  },
  methods: {
    rowClicked (element, value) {
      element.rowSelected = value

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true
    },
    getSDAsInfo () {
      let vm = this

      vm.getSDAsInfoActive = true
      vm.SDAsInfo = []

      let exported = vm.filters.exported.value == 'all' ? '' : vm.filters.exported.value == 'only_exported'

      let since = vm.filters.since.value ? moment(vm.filters.since.value).startOf('day').toDate() : ''
      let until = vm.filters.until.value ? moment(vm.filters.until.value).endOf('day').toDate() : ''

      let dataToSend =
        '/?state=' + 0 +
        '&descending=' + 'lastDateSDA' +
        '&since=' + since +
        '&until=' + until +
        '&exported=' + exported +
        '&limit=' + (vm.filters.limit.value + 1) +
        '&skip=' + vm.filters.skip.value +
        '&seller=' + vm.filters.seller.value +
        '&delegation=' + vm.filters.delegation.value +
        '&clientCode=' + vm.filters.clientCode.value +
        '&legalName=' + vm.filters.legalName.value

      api
        .SDAsInfo
        .getSDAsInfo(dataToSend)
        .then((response) => {
          vm.getSDAsInfoActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.SDAsInfo = response.data.SDAsInfo

          _.each(vm.SDAsInfo, function (element) {
            if (element.normalSDA && element.normalSDA.pdf) {
              let uri_org = new URI(element.normalSDA.pdf.url)
              let pathname = uri_org.pathname()

              element.normalSDA.pdf.url = config.api.baseUrl + pathname
            }

            if (element.systemECSDA && element.systemECSDA.pdf) {
              let uri_org = new URI(element.systemECSDA.pdf.url)
              let pathname = uri_org.pathname()

              element.systemECSDA.pdf.url = config.api.baseUrl + pathname
            }

            if (element.wedoSDA && element.wedoSDA.pdf) {
              let uri_org = new URI(element.wedoSDA.pdf.url)
              let pathname = uri_org.pathname()

              element.wedoSDA.pdf.url = config.api.baseUrl + pathname
            }
            if (element.sebastianSDA && element.sebastianSDA.pdf) {
              let uri_org = new URI(element.sebastianSDA.pdf.url)
              let pathname = uri_org.pathname()

              element.sebastianSDA.pdf.url = config.api.baseUrl + pathname
            }
          })

          if (vm.SDAsInfo.length > 0 && !vm.haveData) {
            vm.haveData = true
          }

          if (vm.SDAsInfo.length > vm.filters.limit.value) {
            vm.nextPage = true

            vm.SDAsInfo.pop()
          } else {
            vm.nextPage = false
          }

          vm.allChecks = _.map(vm.SDAsInfo, (SDA) => {
            let field = {
              id: _.uniqueId('field_'),
              display: true,
              error: false,
              value: {},
              options: {},
              filters: {
                type: 'manyOptions'
              }
            }

            field.value[SDA.objectId] = false

            field.options[SDA.objectId] = {}

            return field
          })
        })
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getSDAsInfo()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getSDAsInfo()
      }
    },
    searchClients (data) {
      let vm = this

      vm.getSearchClients = true

      let dataToSend = '?clientCode=' + data

      api
        .clients
        .getClients(dataToSend)
        .then((response) => {
          vm.getSearchClients = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let clients = response.data.clients

          clients = _.map(clients, (client) => {
            return {
              fakeValue: client.legalName + ' (' + client.clientCode + ')',
              value: client
            }
          })

          vm.createContractWindow.form.fields.client.options = clients
        })
    },
    clientSelected (data) {
      let vm = this

      vm.createContractWindow.form.fields.client.value = data.id
    },
    optionSelected (data) {
      let vm = this

      if (data.action == 'delete') {
        vm.archiveContract(data.element)
      }
    },
    formCreateSubmit () {
      let vm = this

      if (vm.createContractWindow.form.active) {
        return
      }

      vm.createContractWindow.form.active = true

      vm.$root.$emit('validate', [vm.createContractWindow.form.fields, (response) => {
        if (!response.success) {
          vm.createContractWindow.form.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        let dataToSend = {
          client: vm.createContractWindow.form.fields.client.value,
          date: vm.createContractWindow.form.fields.date.value ? moment(vm.createContractWindow.form.fields.date.value).toDate() : moment().toDate(),
          // sdaSp: vm.createContractWindow.form.fields.sdaTypes.value.sdaSp,
          // sdaSpInternet: vm.createContractWindow.form.fields.sdaTypes.value.sdaSpInternet,
          // sdaSpMen: vm.createContractWindow.form.fields.sdaTypes.value.sdaSpMen,
          // sdaSystemEC: vm.createContractWindow.form.fields.sdaTypes.value.sdaSystemEC,
          sdaSebastian: vm.createContractWindow.form.fields.sdaTypes.value.sdaSebastian,
          // sdaSebastianInternet: vm.createContractWindow.form.fields.sdaTypes.value.sdaSebastianInternet,
          // sdaGHD: vm.createContractWindow.form.fields.sdaTypes.value.sdaGHD,
          // sdaWedo: vm.createContractWindow.form.fields.sdaTypes.value.sdaWedo,
          pdf: vm.createContractWindow.form.fields.pdf.value
        }

        api
          .SDAs
          .createContract(dataToSend)
          .then((response) => {
            vm.createContractWindow.form.active = false

            if (response.status != 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              if (response.data.error.code == 101) {
                let message = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              return
            }

            let message = {
              message: [vm.$t('private.contracts.sda.create_contract_window.create_success')],
              type: 'success'
            }

            vm.$root.$emit('showMessage', message)

            vm.getSDAsInfo()

            vm.createContractWindow.display = false
            vm.createContractWindow.form.fields.client.value = ''
            vm.createContractWindow.form.fields.date.value = ''
            // vm.createContractWindow.form.fields.sdaTypes.value.sdaSp = false
            // vm.createContractWindow.form.fields.sdaTypes.value.sdaSpInternet = false
            // vm.createContractWindow.form.fields.sdaTypes.value.sdaSpMen = false
            // vm.createContractWindow.form.fields.sdaTypes.value.sdaSystemEC = false
            vm.createContractWindow.form.fields.sdaTypes.value.sdaSebastian = false
            // vm.createContractWindow.form.fields.sdaTypes.value.sdaSebastianInternet = false
            // vm.createContractWindow.form.fields.sdaTypes.value.sdaGHD = false
            // vm.createContractWindow.form.fields.sdaTypes.value.sdaWedo = false
            // vm.createContractWindow.form.fields.pdf.value = ''
          })
      }])
    },
    parseDate (date) {
      let _date = _.has(date, 'iso') ? date.iso : date

      return moment(_date).format('DD-MM-YYYY')
    },
    validateSdaTypes () {
      let vm = this

      let sdaTypes = vm.createContractWindow.form.fields.sdaTypes
      sdaTypes.options['sdaSystemEC'].disabled = sdaTypes.value['sdaSebastian']
      sdaTypes.options['sdaSebastian'].disabled = sdaTypes.value['sdaSystemEC']

      // let values = _.values(_.omit(sdaTypes.value, ['sdaSystemEC', 'sdaWedo']))
      // let values2 = _.values(_.pick(sdaTypes.value, ['sdaSystemEC', 'sdaWedo']))
      //
      // sdaTypes.options['sdaSp'].disabled = _.some(values2)
      // sdaTypes.options['sdaSpInternet'].disabled = _.some(values2)
      // sdaTypes.options['sdaSpMen'].disabled = _.some(values2)
      // sdaTypes.options['sdaSebastian'].disabled = _.some(values2)
      // sdaTypes.options['sdaSebastianInternet'].disabled = _.some(values2)
      // sdaTypes.options['sdaGHD'].disabled = _.some(values2)
      //
      // sdaTypes.options['sdaSystemEC'].disabled = _.some(values) || sdaTypes.value['sdaWedo']
      // sdaTypes.options['sdaWedo'].disabled = _.some(values) || sdaTypes.value['sdaSystemEC']
      //
      // if (_.some(values)) {
      //   sdaTypes.value['sdaSystemEC'] = false
      //   sdaTypes.value['sdaWedo'] = false
      // }
      //
      // if (_.some(values2)) {
      //   sdaTypes.value['sdaSp'] = false
      //   sdaTypes.value['sdaSpInternet'] = false
      //   sdaTypes.value['sdaSpMen'] = false
      //   sdaTypes.value['sdaSebastian'] = false
      //   sdaTypes.value['sdaSebastianInternet'] = false
      //   sdaTypes.value['sdaGHD'] = false
      // }
    },
    getDelegations () {
      let vm = this

      vm.getDelegationsActive = true

      let dataToSend = '/?descending=createdAt'

      api
        .delegations
        .getDelegations(dataToSend)
        .then((response) => {
          vm.getDelegationsActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let delegations = response.data.delegations

          delegations = _.map(delegations, (delegation) => {
            return {
              fakeValue: delegation.name,
              value: delegation.id
            }
          })

          vm.filters.delegation.options = delegations
        })
    },
    resetDataMigrateSDAsWindow () {
      let vm = this

      vm.migrateSDAsWindow.normalSDAsToCreated = []
      vm.migrateSDAsWindow.normalSDAsWithErrors = []
      vm.migrateSDAsWindow.fields.csvNormal.value = {}
      vm.migrateSDAsWindow.fields.csvNormal.fileReady = false

      vm.migrateSDAsWindow.diamondSDAsToCreated = []
      vm.migrateSDAsWindow.diamondSDAsWithErrors = []
      vm.migrateSDAsWindow.fields.csvNormal.value = {}
      vm.migrateSDAsWindow.fields.csvNormal.fileReady = false

      vm.migrateSDAsWindow.SDAsInfoToUpdated = []
      vm.migrateSDAsWindow.SDAsInfoWithErrors = []
      vm.migrateSDAsWindow.fields.csvInfo.value = {}
      vm.migrateSDAsWindow.fields.csvInfo.fileReady = false
    },
    migrateNormalSDAsSubmit () {
      let vm = this

      let dataToSend = {
        separator: vm.migrateSDAsWindow.fields.separator.value,
        csv: vm.migrateSDAsWindow.fields.csvNormal.value.data
      }

      vm.migrateSDAsWindow.migrateCSVFileActiveNormal = true

      api
        .SDAs
        .migrateCSVFile('/api/sda/migrate/normal', dataToSend)
        .then((response) => {
          vm.migrateSDAsWindow.migrateCSVFileActiveNormal = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.migrateSDAsWindow.normalSDAsToCreated = response.data.normalSDAsToCreated
          vm.migrateSDAsWindow.normalSDAsWithErrors = response.data.normalSDAsWithErrors
        })
    },
    migrateDiamondSDAsSubmit () {
      let vm = this

      let dataToSend = {
        separator: vm.migrateSDAsWindow.fields.separator.value,
        csv: vm.migrateSDAsWindow.fields.csvDiamond.value.data
      }

      vm.migrateSDAsWindow.migrateCSVFileActiveDiamond = true

      api
        .SDAs
        .migrateCSVFile('/api/sda/migrate/diamond', dataToSend)
        .then((response) => {
          vm.migrateSDAsWindow.migrateCSVFileActiveDiamond = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.migrateSDAsWindow.diamondSDAsToCreated = response.data.diamondSDAsToCreated
          vm.migrateSDAsWindow.diamondSDAsWithErrors = response.data.diamondSDAsWithErrors
        })
    },
    migrateSDAsInfoSubmit () {
      let vm = this

      let dataToSend = {
        separator: vm.migrateSDAsWindow.fields.separator.value,
        csv: vm.migrateSDAsWindow.fields.csvInfo.value.data
      }

      vm.migrateSDAsWindow.migrateCSVFileActiveInfo = true

      api
        .SDAsInfo
        .migrateCSVFile(dataToSend)
        .then((response) => {
          vm.migrateSDAsWindow.migrateCSVFileActiveInfo = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.migrateSDAsWindow.SDAsInfoToUpdated = response.data.SDAsInfoToUpdated
          vm.migrateSDAsWindow.SDAsInfoWithErrors = response.data.SDAsInfoWithErrors
        })
    },
    handleSendMailDigitalSignature (element) {
      let vm = this

      if (element.isSendMailDigitalSignature) {
        return
      }

      element.isSendMailDigitalSignature = true

      api
        .SDAs
        .sendMailDigitalSignature({id: element.objectId})
        .then((response) => {
          element.isSendMailDigitalSignature = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message
            if ('message' in response.data) {
              message = {
                message: [response.data.message],
                type: 'error'
              }
            } else {
              if ('error' in response.data) {
                if (response.data.error.code == 101) {
                  message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }
                } else {
                  message = {
                    message: [vm.$t('errors.parse.001')],
                    type: 'error'
                  }
                }
              }
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let message = {
            message: [vm.$t('private.contracts.list.send_mail_success')],
            type: 'success'
          }

          vm.$root.$emit('showMessage', message)
        }).catch(error => {
        console.log('sendMailAutoRenew > error', error)

        element.isSendMailDigitalSignature = false

        let message = {
          message: [vm.$t('errors.parse.001')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)
      })
    },
    exportZipPDFs () {
      let vm = this

      if (vm.exportZipPDFsWindow.downloadZipPDFsActive) {
        let message = {
          message: [vm.$t('private.contracts.sda.please_wait')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      let month = vm.exportZipPDFsWindow.fields.month.value
      let year = vm.exportZipPDFsWindow.fields.year.value

      let since = moment().year(year).month(month - 1).startOf('month').valueOf()
      let until = moment().year(year).month(month - 1).endOf('month').valueOf()

      vm.exportZipPDFsWindow.sessionId = Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 20)
      vm.exportZipPDFsWindow.fields.month.disabled = true
      vm.exportZipPDFsWindow.fields.year.disabled = true
      vm.exportZipPDFsWindow.downloadZipPDFsActive = true

      let dataToSend = {
        since,
        until,
        timeZone: moment.tz.guess(),
        sessionId: vm.exportZipPDFsWindow.sessionId
      }

      api
        .SDAs
        .exportZipPDFs(dataToSend)
        .then((response) => {
          vm.exportZipPDFsWindow.downloadZipPDFsActive = false
          vm.exportZipPDFsWindow.fields.month.disabled = false
          vm.exportZipPDFsWindow.fields.year.disabled = false

          if (response.status == 202) {
            let message = {
              message: [vm.$t('errors.custom.011')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            if (response.data.error.code == 101) {
              let message = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            let message = {
              message: [vm.$t('errors.custom.011')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.exportZipPDFsWindow.downloadZipPDFsActive = true
          vm.exportZipPDFsWindow.fields.month.disabled = true
          vm.exportZipPDFsWindow.fields.year.disabled = true
        })
    },
    generateMoths () {
      let vm = this

      let lang = navigator.language || navigator.userLanguage

      moment.locale(lang)

      let year = vm.exportZipPDFsWindow.fields.year.value

      let dateNow = moment()
      let dateSelectedYear = moment().year(year)
      let monthNow = 12

      if (dateNow.year() === dateSelectedYear.year()) monthNow = dateSelectedYear.month() + 1

      vm.exportZipPDFsWindow.fields.month.options = []
      vm.exportZipPDFsWindow.fields.month.disabled = true

      for (let i = 0; i < monthNow; ++i) {
        vm.exportZipPDFsWindow.fields.month.options.push({
          fakeValue: _.capitalize(moment().month(i).format('MMMM')),
          value: i + 1
        })
      }

      vm.exportZipPDFsWindow.fields.month.value = ''
      vm.exportZipPDFsWindow.fields.month.fakeValue = ''
      vm.exportZipPDFsWindow.fields.month.disabled = false
    }
  },
  components: {
    MenuMoreOptions,
    TextField,
    SelectField,
    CheckboxField,
    DateField,
    SearchField,
    FileField
  },
  created () {
    let vm = this

    vm.getSDAsInfo()

    vm.searchClients('')

    vm.getDelegations()

    for (let i = moment().year() - 2; i <= moment().year(); i++) {
      vm.exportZipPDFsWindow.fields.year.options.push({
        fakeValue: i,
        value: i
      })
    }
  },
  mounted () {
    let vm = this

    let queryProgress = new Parse.Query('Progress')

    let subscriptionProgress = queryProgress.subscribe()

    subscriptionProgress.on('open', () => {
      console.log('subscriptionProgress opened')
    })

    subscriptionProgress.on('create', (event) => {
      vm.exportZipPDFsWindow.progress.display = true
      vm.exportZipPDFsWindow.progress.valueMax = event.get('valueMax')
    })

    subscriptionProgress.on('update', (event) => {
      let sessionId = event.get('sessionId')

      if (vm.exportZipPDFsWindow.sessionId !== sessionId) return

      let status = event.get('status')
      let count = event.get('count')
      let valueMax = event.get('valueMax')

      vm.exportZipPDFsWindow.progress.display = true
      vm.exportZipPDFsWindow.progress.value = count
      vm.exportZipPDFsWindow.progress.valueMax = valueMax
      vm.exportZipPDFsWindow.progress.downloadProgress = 0

      let porcentaje = Math.floor((count / valueMax * 100))

      if (count > 0) {
        $('#progress_id_export_zippdf_sda').text(porcentaje + '%')
        $('#progress_id_export_zippdf_sda').attr('aria-valuenow', porcentaje)
        $('#progress_id_export_zippdf_sda').css('width', porcentaje + '%')
      }

      if (status === 'error') {
        vm.exportZipPDFsWindow.downloadZipPDFsActive = false
        vm.exportZipPDFsWindow.progress.display = false
        vm.exportZipPDFsWindow.fields.month.disabled = false
        vm.exportZipPDFsWindow.fields.year.disabled = false
        vm.exportZipPDFsWindow.display = false

        let message = {
          message: [vm.$t('errors.custom.001')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      if (status === 'finalized') {
        subscriptionProgress.unsubscribe()

        let archive_id = event.get('archive_id')

        if (archive_id) {
          api
            .SDAs
            .getExportZipPDFs(archive_id)
            .then((response) => {
              vm.exportZipPDFsWindow.downloadZipPDFsActive = false
              vm.exportZipPDFsWindow.fields.month.disabled = false
              vm.exportZipPDFsWindow.fields.year.disabled = false

              if (response.status != 200) {
                vm.exportZipPDFsWindow.downloadZipPDFsActive = false

                let message = {
                  message: [vm.$t('errors.custom.001')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              let month = vm.exportZipPDFsWindow.fields.month.value
              let year = vm.exportZipPDFsWindow.fields.year.value

              let since = moment().year(year).month(month - 1).startOf('month').valueOf()
              let until = moment().year(year).month(month - 1).endOf('month').valueOf()

              let file = new Blob([response.data], {type: 'octet/stream'})
              let fileURL = URL.createObjectURL(file)

              FileSaver.saveAs(file, 'pdfs_' + since + '_' + until + '.zip')

              setTimeout(function () {
                vm.exportZipPDFsWindow.downloadZipPDFsActive = false
                vm.exportZipPDFsWindow.progress.display = false
                vm.exportZipPDFsWindow.fields.month.disabled = false
                vm.exportZipPDFsWindow.fields.year.disabled = false
                vm.exportZipPDFsWindow.display = false
              }, 3000)
            })
        }
      }
    })

    subscriptionProgress.on('error', (error) => {
      console.log('on Error')
      console.log(error)
      vm.exportZipPDFsWindow.downloadZipPDFsActive = false
      vm.exportZipPDFsWindow.fields.month.disabled = false
      vm.exportZipPDFsWindow.fields.year.disabled = false
      vm.exportZipPDFsWindow.progress.display = false
      vm.exportZipPDFsWindow.display = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/private/contracts/sda/script.js